import { lazy } from 'react';

export const ActivatePage = lazy(() => import('./ActivatePage'));
